import {
  Backdrop, Button, Card, CardActions, CardContent,
  CardHeader, CircularProgress, Divider,
  GridList, GridListTile, GridListTileBar, IconButton, Modal
} from '@material-ui/core';
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'src/utils/axiosCatalog';
import { openBlob } from 'src/utils/Common';

const useStyles = makeStyles((theme) => ({
  rootCCFile: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    width: 700,
    maxHeight: '100%',
    overflowY: 'auto',
    maxWidth: '100%'
  },
  actionsCCFile: {
    justifyContent: 'flex-end'
  }
}));

function CCFilePopup({
  open, onClose, ReceiptNo, className
}) {
  const classes = useStyles();
  const { t } = useTranslation('common');
  const [loading, setLoading] = useState(false);
  const [CCFileData, setCCFileData] = useState([]);
  const handleCCFileDetayAc = (event, Id, Type) => {
    setLoading(true);
    const config = {
      responseType: 'blob',
    };
    axios.get(`/FileImportExport/ArtemisCCFileDetail/${ReceiptNo}/${Id}/${Type}`, config)
      .then((response) => {
        openBlob(response.data, Id);
        setLoading(false);
      }).catch((error) => {
        setLoading(false);
      });
  };


  useEffect(() => {
    let mounted = true;

    const fetchTodos = () => {
      axios.get(`/GetCCMainFile/${ReceiptNo}`).then((response) => {
        if (mounted) {
          const Deger = response.data === '' ? [] : response.data;
          setCCFileData(Deger);
          setLoading(false);
        }
      }).catch((error) => {
        setLoading(false);
      });
    };
    fetchTodos();
    return () => {
      mounted = false;
    };
  }, [ReceiptNo]);

  if (!open) {
    return null;
  }

  return (
    <Modal
      onClose={() => { onClose(); }}
      open={open}
    >
      <Card
        className={clsx(classes.rootCCFile, className)}
      >
        <CardHeader title={t('Cagri_Merkezi_Dosyalar')} />
        <CardContent className={classes.content}>
          {
              loading
                ? (
                  <Backdrop className={classes.backdrop} open={loading}>
                    <CircularProgress color="inherit" />
                  </Backdrop>
                )
                : ''
            }
          <GridList cellHeight={120} className={classes.gridList}>
            {CCFileData.map((item) => (
              <GridListTile
                key={item.attachmentId}
              >
                <IconButton
                  onClick={(event) => handleCCFileDetayAc(event, item.attachmentId, item.objectType)}
                  aria-label={`büyük resim ${item.name}`}
                >
                  {/* <img src={getImgDetay(item.attachmentId, item.objectType)} alt={item.name} /> */}
                  <PhotoLibraryIcon />
                </IconButton>
                <GridListTileBar
                  title={item.name}
                  subtitle={<span>{item.contentType}</span>}
                />
              </GridListTile>
            ))}
          </GridList>
        </CardContent>
        <Divider />
        <CardActions className={classes.actionsCCFile}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => { onClose(); }}
          >
            {t('Kapat')}
          </Button>
        </CardActions>
      </Card>
    </Modal>
  );
}

CCFilePopup.defaultProps = {
  open: false,
  onClose: () => { }
};

export default CCFilePopup;
